import type React from 'react';
import { useEffect, useState } from 'react';
import { driver } from './driver';

export const PopoverPortal = () => {
  const [portal, setPortal] = useState<React.ReactPortal | null>(null);

  useEffect(() => {
    driver.setPopover = (portal) => setPortal(portal);
  }, []);

  return portal;
};
